import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './external_api_credential.routes';
import ExternalApiCredentialService from '../../components/api/external_api_credential/external_api_credential.service';

export class ExternalApiCredentialController {
    /*@ngInject*/
    constructor($state, ExternalApiCredentialService, $mdDialog, $location, $stateParams) {
        this.ExternalApiCredentialService = ExternalApiCredentialService;
        this.access_key   = '読み込み中';
        this.access_token = '読み込み中';
        this.updated_at   = '読み込み中';
        this.company_id   = $stateParams.company_id;
        this.$location    = $location;
        this.$mdDialog    = $mdDialog;
        this.$state = $state;
        this.dialog = {
            confirm: $mdDialog.confirm({
                disableParentScroll: false,
                title: '本当に変更しますか？',
                ok: '変更する',
                cancel: '変更しない'
            }),
            success: $mdDialog.alert({
                disableParentScroll: false,
                title: '変更しました',
                ok: 'OK'
            }),
            error: $mdDialog.alert({
                disableParentScroll: false,
                title: 'エラーが発生しました',
                ok: 'OK'
            })
        };
    }

    $onInit() {
        this.ExternalApiCredentialService.index({ company_id: this.company_id }, response => {
            this.access_key   = response.access_key;
            this.access_token = response.access_token;
            this.updated_at   = response.updated_at;
        }, err => {
            if(err.status === 404 || err.status === 403) { this.$state.go('oem_main.oem_home'); }
        });
    }

    showConfirm(){
        this.$mdDialog.show(this.dialog.confirm)
            .then(() => {
                this.ExternalApiCredentialService.create(
                    { company_id: this.company_id },
                    (okResponse)  => {
                        this.access_key = okResponse.access_key;
                        this.access_token = okResponse.access_token;
                        this.updated_at = okResponse.updated_at;
                        this.$mdDialog.show(this.dialog.success);
                    },
                    (errResponse) => {
                        this.$mdDialog.show(this.dialog.error.content(errResponse.data.message));
                    }
                );
            });
    }
}

export default angular.module('leptonApp.externalApiCredential', [uiRouter, ExternalApiCredentialService])
    .config(routing)
    .component('externalApiCredential', {
        template: require('./external_api_credential.html'),
        controller: ExternalApiCredentialController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/external_api_credential/external_api_credential.component.js